import { markRaw } from 'vue';
import type { Component } from 'vue';
import { RelationshipType } from '@apparatix/schemas/Relationship';
import BuildingIcon from '@primeicons/vue/building';
import IdCardIcon from '@primeicons/vue/id-card';
import FileIcon from '@primeicons/vue/file';
import UserPlusIcon from '@primeicons/vue/user-plus';
import DollarIcon from '@primeicons/vue/dollar';
import CalendarIcon from '@primeicons/vue/calendar';
import ChartBarIcon from '@primeicons/vue/chart-bar';
import BillboardIcon from '@apparatix/icons/BillboardIcon.vue';

export type SectionConfig = {
  backgroundColor: string;
  color: string;
  icon: Component;
  plural: string;
  singular: string;
}

export type ObjectName = 'Activity' | 'Projection';

export const SectionIconography: Record<RelationshipType, SectionConfig> = {
  Account: {
    backgroundColor: '#CCFBF1',
    color: '#14B8A6',
    icon: markRaw(BuildingIcon),
    plural: 'Accounts',
    singular: 'Account',
  },
  Contact: {
    backgroundColor: '#FAE8FF',
    color: '#D946EF',
    icon: markRaw(IdCardIcon),
    plural: 'Contacts',
    singular: 'Contact',
  },
  Document: {
    backgroundColor: '#F3E8FF',
    color: '#A855F7',
    icon: markRaw(FileIcon),
    plural: 'Documents',
    singular: 'Document',
  },
  Inventory: {
    backgroundColor: '#E0F2FE',
    color: '#0284C7',
    icon: markRaw(BillboardIcon),
    singular: 'Inventory',
    plural: 'Inventory',
  },
  Lead: {
    backgroundColor: '#FEF3C7',
    color: '#F59E0B',
    icon: markRaw(UserPlusIcon),
    plural: 'Leads',
    singular: 'Lead',
  },
  Opportunity: {
    backgroundColor: '#ECFCCB',
    color: '#84CC16',
    icon: markRaw(DollarIcon),
    plural: 'Opportunities',
    singular: 'Opportunity',
  },
} as const;

export const ObjectIconography: Record<ObjectName, SectionConfig> = {
  Activity: {
    backgroundColor: '#DBEAFE',
    color: '#3B82F6',
    icon: markRaw(CalendarIcon),
    plural: 'Activities',
    singular: 'Activity',
  },
  Projection: {
    backgroundColor: '#F1F5F9',
    color: '#94A3B8',
    icon: markRaw(ChartBarIcon),
    plural: 'Projections',
    singular: 'Projection',
  },
} as const;

export const SectionIconographyOptions: SectionConfig[] = Object.freeze(
  Object.keys(SectionIconography).map(key => SectionIconography[key]),
);

